import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77aeedc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-wrapper" }
const _hoisted_2 = { class: "banner-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "points-display" }
const _hoisted_5 = { class: "highlight" }
const _hoisted_6 = { class: "custom-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "VS", -1 /* HOISTED */))
const _hoisted_8 = { class: "custom-label" }
const _hoisted_9 = { class: "match-time" }
const _hoisted_10 = { class: "option-wrapper" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "opt-text" }
const _hoisted_14 = { class: "opt-odd" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "opt-text" }
const _hoisted_18 = { class: "opt-odd" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "opt-text" }
const _hoisted_22 = { class: "opt-odd" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "opt-text" }
const _hoisted_26 = { class: "opt-odd" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "opt-text" }
const _hoisted_30 = { class: "opt-odd" }
const _hoisted_31 = { class: "bet-popup-container" }
const _hoisted_32 = { class: "bet_title" }
const _hoisted_33 = { class: "point_list_class" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "rule-popup-container" }
const _hoisted_36 = { class: "rule_title" }
const _hoisted_37 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showTopBar)
      ? (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 0,
          title: _ctx.$t('竞猜'),
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
        }, null, 8 /* PROPS */, ["title"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", { src: $setup.guessing_bg_icon }, null, 8 /* PROPS */, _hoisted_3),
        _createVNode(_component_van_button, {
          class: "rules-btn",
          size: "small",
          round: "",
          onClick: $setup.ruleAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.t('活动规则')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString($setup.t('我的积分')) + ": ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.points), 1 /* TEXT */)
        ]),
        _createElementVNode("div", {
          class: "history-link",
          onClick: $setup.guessRecord
        }, _toDisplayString($setup.t('竞猜记录')) + " >", 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" 3. 下方赛事列表：van-list  + van-cell "),
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.refreshing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.refreshing) = $event)),
      onRefresh: $setup.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          modelValue: $setup.loading,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
          finished: $setup.finished,
          "finished-text": "",
          onLoad: $setup.onLoad,
          class: "van-list-class"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.matcheList, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.match_id,
                class: "match-cell",
                clickable: "",
                onClick: ($event: any) => ($setup.onMatchClick(item))
              }, {
                default: _withCtx(() => [
                  _createCommentVNode(" 自定义第一行标题 "),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(item.home_name) + _toDisplayString($setup.t('（主）')), 1 /* TEXT */),
                    _hoisted_7,
                    _createElementVNode("p", null, _toDisplayString(item.away_name) + _toDisplayString($setup.t('（客）')), 1 /* TEXT */)
                  ]),
                  _createCommentVNode(" 自定义第二行：截止时间 + 三选/二选按钮 "),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.t('截止时间')) + " " + _toDisplayString(item.match_time), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_10, [
                      _createCommentVNode(" 足球 (三选) "),
                      (item.type_id == 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-item", { selected: item.order.odds_type == 'odds_win' }]),
                              onClick: _withModifiers(($event: any) => ($setup.selectOption(item, 'odds_win')), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: item.order.odds_type == 'odds_win' ? $setup.left_sel : $setup.left_nor
                              }, null, 8 /* PROPS */, _hoisted_12),
                              _createElementVNode("div", _hoisted_13, _toDisplayString($setup.t('主队赢')), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_14, _toDisplayString(item.odds_win), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_11),
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-item", { selected: item.order.odds_type == 'odds_draw' }]),
                              onClick: _withModifiers(($event: any) => ($setup.selectOption(item, 'odds_draw')), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: item.order.odds_type == 'odds_draw' ? $setup.middle_sel : $setup.middle_nor
                              }, null, 8 /* PROPS */, _hoisted_16),
                              _createElementVNode("div", _hoisted_17, _toDisplayString($setup.t('平')), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(item.odds_draw), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_15),
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-item", { selected: item.order.odds_type == 'odds_loss' }]),
                              onClick: _withModifiers(($event: any) => ($setup.selectOption(item, 'odds_loss')), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: item.order.odds_type == 'odds_loss' ? $setup.right_sel : $setup.right_nor
                              }, null, 8 /* PROPS */, _hoisted_20),
                              _createElementVNode("div", _hoisted_21, _toDisplayString($setup.t('客队赢')), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(item.odds_loss), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_19)
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" 篮球 (二选) "),
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-item", { selected: item.order.odds_type == 'odds_win' }]),
                              onClick: _withModifiers(($event: any) => ($setup.selectOption(item, 'odds_win')), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: item.order.odds_type == 'odds_win' ? $setup.bask_left_sel : $setup.bask_left_nor
                              }, null, 8 /* PROPS */, _hoisted_24),
                              _createElementVNode("div", _hoisted_25, _toDisplayString(item.home_name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_26, _toDisplayString(item.odds_win), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_23),
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-item", { selected: item.order.odds_type == 'odds_loss' }]),
                              onClick: _withModifiers(($event: any) => ($setup.selectOption(item, 'odds_loss')), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: item.order.odds_type == 'odds_loss' ? $setup.bask_right_sel : $setup.bask_right_nor
                              }, null, 8 /* PROPS */, _hoisted_28),
                              _createElementVNode("div", _hoisted_29, _toDisplayString(item.away_name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_30, _toDisplayString(item.odds_loss), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_27)
                          ], 64 /* STABLE_FRAGMENT */))
                    ])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "finished"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_van_popup, {
      show: $setup.showBetAlertView,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.showBetAlertView) = $event)),
      position: "center",
      round: "",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('选择下注积分')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pointArr, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass($setup.pointSelectIndex == index ? 'point_active_class' : ''),
                onClick: ($event: any) => ($setup.pointSelectAction(index))
              }, _toDisplayString(item), 11 /* TEXT, CLASS, PROPS */, _hoisted_34))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createVNode(_component_van_button, {
            round: "",
            onClick: $setup.comfirmGuessAction,
            color: "#F9D66C",
            class: "comfirmBtn",
            text: _ctx.$t('下注')
          }, null, 8 /* PROPS */, ["text"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_van_popup, {
      show: $setup.showRuleAlertView,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.showRuleAlertView) = $event)),
      position: "bottom",
      round: "",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("p", _hoisted_36, _toDisplayString($setup.rule_title), 1 /* TEXT */),
          _createElementVNode("div", {
            innerHTML: $setup.rule_html,
            class: "v-htmlclass"
          }, null, 8 /* PROPS */, _hoisted_37)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}